import React, { ReactElement } from 'react'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import HeaderFont from '../../HelperClass/HeaderFont'
import HeaderTemplate from '../../HelperClass/Template/Header'
import StatisticsRowItem from '../../HelperClass/RowItem/StatisticsRowItem'
import { DartsFormat } from '../../HelperClass/StandingsRowTypes'

export type Props = {
    /**
     * Is there a more button
     */
    hasMore?: boolean
    format: DartsFormat
} & TestID

const DartsHeader = ({ hasMore, format, testID }: Props): ReactElement => {
    return (
        <HeaderTemplate competitorLabel="Spieler" testID={testID} hasMore={hasMore}>
            {format === 'GRAND_SLAMS' ? (
                <StatisticsRowItem width={[26, 26, 32]}>
                    <HeaderFont align="center">Sp.</HeaderFont>
                </StatisticsRowItem>
            ) : null}
            <StatisticsRowItem width={format === 'GRAND_SLAMS' ? [34, 34, 40] : [56, 56, 60]}>
                <HeaderFont align="center">
                    {format === 'GRAND_SLAMS' ? 'S-N' : 'Eventsiege'}
                </HeaderFont>
            </StatisticsRowItem>
            <StatisticsRowItem width={48}>
                <HeaderFont align="center">Legs</HeaderFont>
            </StatisticsRowItem>
            <StatisticsRowItem width={[27, 27, 32]}>
                <HeaderFont align="center">Diff.</HeaderFont>
            </StatisticsRowItem>
            <StatisticsRowItem width={[26, 26, 32]}>
                <HeaderFont align="center">Pkt.</HeaderFont>
            </StatisticsRowItem>
        </HeaderTemplate>
    )
}

export default DartsHeader
